import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as e } from "../../../core/maybe.js";
import { TaskPriority as t, ImmediateTask as r } from "../../support/Scheduler.js";

var s = /*#__PURE__*/function () {
  function s(_s, u) {
    _classCallCheck(this, s);

    this._stage = _s, this._textureRequests = new Map(), this._frameTask = e(u) ? u.registerTask(t.TEXTURE_UNLOAD) : r;
  }

  _createClass(s, [{
    key: "destroy",
    value: function destroy() {
      var _this = this;

      this._frameTask.remove(), this._textureRequests.forEach(function (e) {
        return _this._releaseTextureRequest(e);
      }), this._textureRequests.clear();
    }
  }, {
    key: "fromData",
    value: function fromData(e, t) {
      var _this2 = this;

      var r = this.makeUid(e);

      var _s2 = this._textureRequests.get(r);

      return _s2 || (_s2 = {
        referenceCount: 0,
        texture: t(),
        textureAsync: null,
        abortController: null
      }, this._stage && (this._stage.add(_s2.texture), this._stage.loadSynchronous(_s2.texture)), this._textureRequests.set(r, _s2)), _s2.referenceCount++, {
        uid: r,
        texture: _s2.texture,
        release: function release() {
          return _this2._release(r);
        }
      };
    }
  }, {
    key: "_release",
    value: function _release(e) {
      var _this3 = this;

      if (!this._textureRequests) return;

      var t = this._textureRequests.get(e);

      t ? (t.referenceCount < 1 && console.warn("TextureCollection: reference count is < 1 for " + e), t.referenceCount--, t.referenceCount < 1 && this._frameTask.schedule(function () {
        return _this3._releaseNow(e);
      })) : console.warn("TextureCollection: texture doesn't exist: '".concat(e, "'"));
    }
  }, {
    key: "test",
    get: function get() {
      return {
        textureRequests: this._textureRequests
      };
    }
  }, {
    key: "_releaseNow",
    value: function _releaseNow(e) {
      if (!this._textureRequests) return;

      var t = this._textureRequests.get(e);

      !t || t.referenceCount > 0 || (this._releaseTextureRequest(t), this._textureRequests.delete(e));
    }
  }, {
    key: "_releaseTextureRequest",
    value: function _releaseTextureRequest(e) {
      var t;
      e.texture ? null == (t = this._stage) || t.remove(e.texture) : e.abortController && (e.abortController.abort(), e.abortController = null);
    }
  }, {
    key: "makeUid",
    value: function makeUid(t) {
      var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return e(r) ? "".concat(t, ".").concat(r, "px") : t;
    }
  }]);

  return s;
}();

export { s as TextureCollection };